import e, { useState as N } from "react";
import { useTranslation as S } from "react-i18next";
import y from "classnames";
import { getTicketServiceTypeStr as K } from "../../../../../features/api/models/ticket/utils.js";
import { KioskService as P } from "../../components/KioskService/KioskService.js";
import { KioskTitle as _ } from "../../components/KioskTitle/KioskTitle.js";
import { useKioskLanding as b } from "../../context.js";
import { KioskLanguageSelector as C } from "../../components/KioskLanguageSelector/KioskLanguageSelector.js";
import { KioskButton as R } from "../../components/KioskButton/KioskButton.js";
import { KioskHeaderImg as W } from "../../components/KioskHeaderImg/KioskHeaderImg.js";
import s from "./service.module.scss.js";
import { useKioskMenus as x } from "../../hooks/useKioskMenus.js";
function z() {
  const {
    configuration: t,
    kioskId: k,
    testMode: u,
    virtualKeyboard: p,
    lang: n,
    goTo: d
  } = b(), {
    groupedMenus: v
  } = x(), { t: m } = S(), [g, f] = N(!1), a = t == null ? void 0 : t.service.text[n], i = (t == null ? void 0 : t.common.settings.supportedLanguages.slice(0, 3)) ?? [];
  i.includes(n) || (i[i.length - 1] = n);
  const h = (o) => {
    if (g) {
      o.preventDefault();
      return;
    }
    f(!0);
  };
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "service", className: s.servicePage }, /* @__PURE__ */ e.createElement(W, null), /* @__PURE__ */ e.createElement("div", { className: s.mainArea }, /* @__PURE__ */ e.createElement("div", { className: s.services }, /* @__PURE__ */ e.createElement(_, { text: (a == null ? void 0 : a.service_title) || m("kioskLanding.service.title") }), /* @__PURE__ */ e.createElement("div", { className: s.serviceList }, Object.entries(v).map(([o, E]) => {
    const l = E.find((c) => c.language === n);
    if (!t)
      return null;
    const r = new URL(t.common.settings.shopUrl);
    r.searchParams.set("kiosk-mode", "true"), r.searchParams.set("kiosk-id", k), r.searchParams.set("ref", "kiosk-landing"), l && (r.searchParams.set("lang", l.language), r.searchParams.set("service", K(l.serviceType))), u && r.searchParams.set("kiosk-test-mode", "true"), p && r.searchParams.set("virtual-keyboard", "true");
    const L = r.toString();
    return /* @__PURE__ */ e.createElement(
      "a",
      {
        href: L,
        key: o,
        onClick: (c) => h(c),
        className: y({
          [s.kioskServiceWrapper]: !0,
          [s.kioskServiceWrapper__disabled]: !l || g
        })
      },
      /* @__PURE__ */ e.createElement(
        P,
        {
          type: Number(o)
        }
      )
    );
  }))), i.length > 1 && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: s.languagesContainer,
      style: {
        "--borderColor": (t == null ? void 0 : t.common.design.colors.line) || "#000000"
      }
    },
    /* @__PURE__ */ e.createElement("div", { className: s.languagesWrapper }, /* @__PURE__ */ e.createElement("div", { className: s.languagesTitle }, (a == null ? void 0 : a.choose_language) || m("kioskLanding.language.title")), /* @__PURE__ */ e.createElement("div", { className: s.languageSelectorWrapper }, /* @__PURE__ */ e.createElement(C, { langs: i })), t && t.common.settings.supportedLanguages.length > 3 && /* @__PURE__ */ e.createElement(
      R,
      {
        type: "secondary",
        onClick: () => d("languages")
      },
      (a == null ? void 0 : a.other_languages) || m("kioskLanding.service.otherLanguages")
    ))
  )));
}
export {
  z as Service
};
//# sourceMappingURL=Service.js.map
